export default __webpack_public_path__ + "static/media/about-img.2ff92667.jpg";